import axios from "axios";
import { API } from "./uploads";
import { getSessionId } from "./session";

export async function getAnalysis(uploadId) {
  const res = await axios.get(`${API}/uploads/${uploadId}/analysis`, {
    headers: { "X-Session-Id": getSessionId() },
  });
  return res.data;
}

export async function retryAnalysis(uploadId) {
  const res = await axios.post(
    `${API}/uploads/${uploadId}/analysis/retry`,
    null,
    { headers: { "X-Session-Id": getSessionId() } },
  );
  return res.data;
}
